import { useTranslation } from 'react-i18next';
import { ShieldCheck, AlertTriangle } from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';
import './ScannabilityInfo.css';

export const ScannabilityInfo: React.FC = () => {
  const { t } = useTranslation('create');
  const config = useAppStore(state => state.config);
  const logoFile = useAppStore(state => state.logoFile);
  const content = useAppStore(state => state.content);

  if (!content) return null;

  const warnings: string[] = [];

  // Scannability heuristics
  if (config.foregroundType === 'solid' && config.foregroundColor.toLowerCase() === config.backgroundColor.toLowerCase()) {
    warnings.push(t('create.scannability.contrast', 'Low contrast between foreground and background.'));
  }
  
  if (logoFile && config.logoSize > 30 && config.errorCorrection !== 'H') {
    warnings.push(t('create.scannability.logoSize', 'Large logo may require "H" error correction.'));
  }

  const isGood = warnings.length === 0;

  return (
    <div className={`scannability-info ${isGood ? 'good' : 'warning'}`}>
      <div className="scannability-header">
        {isGood ? <ShieldCheck size={18} /> : <AlertTriangle size={18} />}
        <span className="scannability-title">
          {isGood ? t('create.scannability.goodTitle', 'Good Scannability') : t('create.scannability.warningTitle', 'Scannability Warning')}
        </span>
      </div>
      {warnings.length > 0 && (
        <ul className="scannability-list">
          {warnings.map((w, i) => <li key={i}>{w}</li>)}
        </ul>
      )}
    </div>
  );
};
